import { BaseStore } from 'fluxible/addons';
import Actions from '../constants/Actions';

class ComplianceStore extends BaseStore {

  static storeName = 'ComplianceStore';

  static handlers = {
    [Actions.UI__SIDEBAR_TOGGLED]:'handleSidebarToggle'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.sidebarActive = true;
  }

  handleSidebarToggle() {
    this.sidebarActive = !this.sidebarActive;
    this.emitChange();
  }

  isSidebarActive() {
    return this.sidebarActive;
  }

  dehydrate() {
    return {
      sidebarActive: this.sidebarActive
    };
  }

  rehydrate(state) {
    this.sidebarActive = state.sidebarActive;
  }
}

export default ComplianceStore;



// WEBPACK FOOTER //
// ./src/stores/ComplianceStore.js